var urlParams;

;(function($, undefined){
    'use strict';

    var rnn = window.rnn;
    var facetData;
    var $facetsMenu;
    var firstRun = true;

    /*
    the landing pages should really just use the listWidget function but it was proving
    difficult to keep them working with their differing functionality so I gave up (for now)
    */
    function landingWidget($list) {
        $list.on('click', '.listItem:not(.listItemInput)', function () {
            var children = $(this).data('children');
            var href = $(this).data('href');
            var value = $(this).data('value');
            var title = $(this).find('.title').html();
            var container = $list.data('container');
            var carousel = $list.data('carousel');

            if (children) {
                var parsed;

                if (typeof children === 'object') {
                    parsed = children;
                } else {
                    parsed = jQuery.parseJSON(children);
                }

                if (parsed) {
                    $list.data('href', href);
                    var source = $('#hdlbars-classifieds-category-list').html();
                    if (source) {
                        var template = Handlebars.compile(source);
                        var html = template(parsed);
                        var $container = $list.find(container);
                        var $items = $container.find('.item');

                        if ($items.length > 1) {
                            $items.last().remove();
                        }

                        $container.append(html)
                                  .find('.classifiedsHeader a')
                                  .html(title);

                        $list.find('.listAll .btn')
                             .prop('href', href)
                             .on('click', function (e) {
                                e.preventDefault();
                                var keywords = $list.find('.keywords').val();
                                if (keywords) {
                                    href += '?keywords=' + keywords;
                                }
                                document.location.href = href;
                             })
                             .find('.text').html(title);

                        listKeyword($list);
                        if (carousel === true) {
                            var $carousel = $list.find('.carousel');
                            var listOffset = $('.listWidgetContent').offset().top;

                            // if the user has scrolled past the top of the pillars we'll scroll them back
                            if ($('body').scrollTop() > listOffset) {
                                $('html,body').animate({ scrollTop: listOffset }, 200);
                            }

                            $carousel.carousel('next')
                                     .carousel('pause');

                            $container.on('click', '.classifiedsHeader a', function (e) {
                                e.preventDefault();
                                $carousel.carousel('prev')
                                         .carousel('pause');
                            });
                        }
                    }
                }
            } else if (href) {
                $list.data('href', href);
                listGotoURL($list);
            }
        });
    }

    function listWidget($list) {

        var $header = $list.find('.classifiedsHeaderWidget');
        var $spot;

        if ($facetsMenu) {
            $spot = $facetsMenu.find('#facetMain .listItem.opened');
        }

        if ($header.length > 0) {
            $header.html($spot.find('.text').text());
        }

        $list.on('click', '.listItem', function () {
            var children = $(this).data('children');
            var href = $(this).data('href');
            var value = $(this).data('value');
            var title = $(this).find('.title').html();
            var container = $list.data('container');
            var carousel = $list.data('carousel');

            if (children) {
                var parsed;

                if (typeof children === 'object') {
                    parsed = children;
                } else {
                    parsed = jQuery.parseJSON(children);
                }
                if (parsed) {
                    var template = $('#hdlbars-classifieds-list').html();
                    if (template) {
                        var compiled = Handlebars.compile(template);
                        var html = compiled(parsed);
                        if(html) {
                            var $html = $(html);

                            $html.addClass('openedWidget');

                            $('<div class="listItemSubheader">' + title + '</div>').insertAfter($html.find('.cancelWidget'));

                            cancelWidget($html);

                            $facetsMenu.find('.item').hide();
                            $facetsMenu.find('.listWidgetContent')
                                       .append($html)
                                       .find('.item:last .classifiedsHeaderWidget')
                                       .addClass('arrow-back')
                                       .on('click', function () {
                                           $facetsMenu.find('.listWidgetContent .item:last')
                                                      .remove()
                                                      .end()
                                                      .find('.openedWidget')
                                                      .show();
                                       });

                            listWidget($html);
                        }
                    }
                }
            } else if (value) {
                selectedData[$spot.data('slug')] = value;
                $spot.addClass('selected').find('.value').html(title);
                getFacetData(true, function () {
                    closeSelectedFacet();
                });

            }
        });
    }

    function multiselectWidget($list, slug) {
        var $spot = $facetsMenu.find('#facetMain .listItem.opened');
        var $header = $list.find('.classifiedsHeaderWidget .text');
        var value = '';

        if ($header.length > 0) {
            $header.html($spot.find('.text').text());
        }

        $list.on('click', '.listItem', function () {
            $(this).toggleClass('selected');
        });

        $list.find('#multiselectBtn').on('click', function () {
            multiselectWidgetAction($list, $spot);
        });
        // if we already have selected values, select them
        if (selectedData[slug] && selectedData[slug].length > 0) {
            for (var i = 0; i < selectedData[slug].length; i++) {
                if (selectedData[slug][i].hasOwnProperty('name')) {
                    // this sucks
                    $list.find('.listItem .title:contains("' + selectedData[slug][i].name + '")')
                         .parent('.listItem')
                         .addClass('selected');
                }
            }
        }
    }
    function multiselectWidgetAction($list, $spot) {

        var $selected = $list.find('.selected');
        var multiData = [];
        var string = '';
        var data;
        var slug = $spot.data('slug');

        $selected.each(function (index) {
            data = $(this).data('value');
            if (index > 0) {
                string += ' / ';
            }
            string += data.name;
            multiData.push(data);

        });
        $spot.addClass('selected').find('.value').html(string);

        selectedData[slug] = multiData;

        getFacetData(true, function () {
            closeSelectedFacet();
        });
    }

    function keywordWidget($list) {

        var $spot = $facetsMenu.find('#facetMain .listItem.opened');
        var $header = $list.find('.classifiedsHeaderWidget');
        var value = '';
        var slug = $spot.data('slug');

        if ($header.length > 0) {
            $header.html($spot.find('.text').text());
        }

        if (selectedData[slug]) {
            if (selectedData[slug].hasOwnProperty('value')) {
                value = selectedData[slug].value;
            }
        }

        $list.find('#keywordBtn').on('click', function (e) {
            e.preventDefault();
            keywordWidgetAction($list, $spot);

        });
        $list.find('#keywordInput').val(value).on('keypress', function(e) {
            if(e.which === 13) {
                keywordWidgetAction($list, $spot);
            }
        });
    }

    function keywordWidgetAction($list, $spot) {
        var value = $list.find('#keywordInput').val();
        var slug = $spot.data('slug');

        if (value) {
            selectedData[slug] = {
                'value': value,
                'slug': slug,
                'widget': 'keyword'
            };
            $spot.addClass('selected').find('.value').text(value);
            getFacetData(true, function () {
                closeSelectedFacet();
            });
        } else {
            errorAlert($list.find('.listItem'), 'Please enter a keyword value');
        }
    }

    function rangeWidget($list) {
        var $header = $list.find('.classifiedsHeaderWidget');
        var $spot, current, min, max;

        if ($facetsMenu) {
            $spot = $facetsMenu.find('#facetMain .listItem.opened');
        }

        if ($header.length > 0) {
            $header.html($spot.find('.text').text());
        }
        $list.find('#rangeBtn').on('click', function (e) {
            e.preventDefault();
            rangeWidgetAction($list, $spot);
        });

        if (selectedData[$spot.data('slug')]) {
            current = selectedData[$spot.data('slug')];
            if (current.hasOwnProperty('min')) {
                $list.find('#minInput').val(current.min);
            }
            if (current.hasOwnProperty('max')) {
                $list.find('#maxInput').val(current.max);
            }
        }

        $list.find('#minInput, #maxInput').on('keypress', function(e) {
            if(e.which === 13) {
                rangeWidgetAction($list, $spot);
            }
        });
    }

    function rangeWidgetAction($list, $spot) {
        var $min = $list.find('#minInput');
        var $max = $list.find('#maxInput');
        var min = $min.val();
        var max = $max.val();
        var ceiling = $max.attr('max_value');
        var pass = true;

        if (min) {
            min = parseInt(min);
            if (isNaN(min)) {
                pass = false;
                $list.find('#minInput').val('');
            }
        }
        if (max) {
            max = parseInt(max);
            if (isNaN(max)) {
                pass = false;
                $list.find('#maxInput').val('');
            }
        }
        if (ceiling) {
            ceiling = parseInt(ceiling);
        }
        removeAlert();
        if (min === '' && max === '') {
            errorAlert($list.find('.listItem'), 'Please enter either a Min or Max value.');
        } else {
            if (pass) {
                if (ceiling && ((min && min > ceiling) || (max && max > ceiling)))
                    errorAlert($list.find('.listItem'), 'Maximum value is ' + ceiling + '.');
                else {
                    if (min !== '' && max !== '' && min > max) {
                        errorAlert($list.find('.listItem'), 'Please enter a Min value lower than the Max value.');
                    } else {
                        selectedData[$spot.data('slug')] = {
                            'slug': $spot.data('slug'),
                            'min': min,
                            'max': max,
                            'widget': 'range'
                        };
                        $spot.addClass('selected').find('.value').html(rangeString(min, max));
                        getFacetData(true, function () {
                            closeSelectedFacet();
                        });
                    }
                }
            } else {
                errorAlert($list.find('.listItem'), 'Please enter both Min and Max as numeric values.');
            }
        }
    }

    function initFacets() {

        if ($facetsMenu.length > 0) {

            $facetsMenu.detach().prependTo('body');

            $('#refineFacetsBtn').on('click', function (e) {
                e.preventDefault();
                $facetsMenu.addClass('open');
                resizeWindow();
                $(window).resize(_.debounce(function() {
                    resizeWindow();
                }, 200));
                // check if the ajax isn't currently loading
                if ($facetsMenu.find('.loading').length === 0) {
                    buildFacets();
                }
            });

             $facetsMenu.find('.cancelFacet').click(function (e) {
                e.preventDefault();
                closeFacets($facetsMenu);
            });

             $facetsMenu.find('#viewResults').click(function (e) {
                e.preventDefault();
                if (!$(this).hasClass('disabled')) {
                    generateUrl();
                }
             });
        }
    }

    // this builds the ajax url and then does the ajax call
    // this is similar to the function below to generate the search url, one day i should combine them
    function getFacetData(build, callback) {

        if (typeof callback === 'undefined') { callback = false; }

        var url = '/menu/json/?';
        var props = JSON.parse(JSON.stringify(selectedData)); // making a deep clone as we're using delete below
        var facet;

        // there should be a better way of doing this
        if (window.location.href.indexOf("classifieds") > -1) {
            url = '/classifieds' + url;
        }

        facet = props.location;
        if (facet) {
            if (facet.hasOwnProperty('slug')) {
                url += 'location=' + facet.slug + '&';
            } else {
                url += 'location=all-locations&';
            }
            delete props.location;
        } else {
            // location is required apparently
            url += 'location=all-locations&';
        }

        facet = props.classification;
        if (facet.length > 0) {
            $.each(facet, function (index, value) {
                if (value.slug) {
                    url += 'classification=' + value.slug + '&';
                }
            });
            delete props.classification;
        }
        facet = props.suburb;
        if (facet) {
            if (facet.hasOwnProperty('slug')) {
                url += 'suburb=' + facet.id + '&';
            }
            delete props.suburb;
        }

        facet = props.price;
        if (facet) {
            if (facet.hasOwnProperty('min') || facet.hasOwnProperty('max')) {
                if (facet.min !== '' || facet.max !== '') {
                    url += 'price=' + facet.min + '-' + facet.max + '&';
                }
            }
            delete props.price;
        }

        facet = props.keyword;
        if (facet) {
            if (facet.hasOwnProperty('value') && facet.value !== '') {
                url += 'keywords=' + facet.value + '&';
            }
            delete props.keyword;
        }

         // loop through the left over selected facets and add them to the path
        $.each(props, function (index, value) {
            if (value.hasOwnProperty('slug')) {
                if (value.widget === 'range') {
                    url += value.slug + '=' + value.min + '-' + value.max + '&';
                } else if (value.widget === 'keyword') {
                    url += value.slug + '=' + value.value + '&';
                } else {
                    url += 'refined_facets=' + value.slug + '&';
                }
            } else if (value.length > 0) {
                for (var i = 0; i < value.length; i++) {
                    if (value[i].hasOwnProperty('slug')) {
                        if (value[i].widget === 'range') {
                            url += value[i].slug + '=' + value[i].min + '-' + value[i].max + '&';
                        } else if (value.widget === 'freeform') {
                            url += value.slug + '=' + value.value + '&';
                        } else {
                            url += 'refined_facets=' + value[i].slug + '&';
                        }
                    }
                }
            } else {
                // on page load grab any query string values that are left over
                if (firstRun) {
                    if (urlParams[index]) {
                        url += index + '=' + urlParams[index] + '&';
                        selectedData[index] = {'slug': index, 'value': urlParams[index]};
                    }
                }
            }
        });
        closeSelectedFacet();
        startLoading();
        $.ajax({
            dataType: 'json',
            url: url,
            success: function (data) {
                finishLoading();
                removeAlert();
                // if theres no results don't do anything but display a msg
                if (data.total === 0) {
                    closeSelectedFacet();
                    $facetsMenu.find('#viewResults').addClass('disabled');
                    updateTotalResults(0);
                    errorAlert($facetsMenu.find('.msgContainer'), 'Your search did not match any listings. ' +
                                        'Try reducing the number of refinements.');
                }
                // allow a rebuild on the first run even if there are no results
                if (data.total > 0 || firstRun === true) {
                    facetData = data;
                    $facetsMenu.find('#viewResults').removeClass('disabled');
                    if (build === true) {
                        buildFacets();
                    }
                    if (callback) {
                        callback();
                    }
                    firstRun = false;
                }
            },
            error: function () {
                finishLoading();
                errorAlert($facetsMenu.find('.msgContainer'), 'There was a system error, please try again.');
            }
        });

    }
    /*
        The big daddy function, this goes through each facet returned from the ajax call, cleans the json
        object for the facet (because they're all unique snowflakes) and builds the facet,
        binds data and sets up events
    */
    function buildFacets() {
        var dataField, cleanData, current;

        // Keyword stuff
        current = selectedData[$facetsMenu.find('.facet-keywords').data('slug')];
        if (current) {
            if (current.hasOwnProperty('value')) {
                if (current.value !== '') {
                    $facetsMenu.find('.facet-keywords')
                               .addClass('selected')
                               .data('value', current.value)
                               .find('.value')
                               .html(current.value);
                }
            }
        }

        // Location stuff
        cleanData = [];
        current = selectedData[$facetsMenu.find('.facet-location').data('slug')];
        if (facetData && facetData.hasOwnProperty('location_facets')) {
            dataField = facetData.location_facets;
            $.each(dataField, function (index, itemData) {
                var temp = itemData[0];
                temp.value = JSON.stringify(temp);
                if(temp.slug === "all-locations") {
                    cleanData.unshift(temp);
                } else {
                    cleanData[cleanData.length] = temp;
                }
            });
        }

        $facetsMenu.find('.facet-location')
                   .data('widget', 'list')
                   .data('data', cleanData);

        if (current) {
            if (current.hasOwnProperty('name')) {
                $facetsMenu.find('.facet-location')
                           .addClass('selected')
                           .data('value', current.value)
                           .find('.value')
                           .html(current.name);
            }
        }

        // Classification stuff
        cleanData = [];
        dataField = '';
        if (facetData) {
            dataField = facetData.classification_facets;
        }
        current = selectedData[$facetsMenu.find('.facet-classifications').data('slug')];

        if (current) {
            current = current[current.length-1];
        }

        if (dataField.length > 0) {
            var dataClass = [];
            var parent = {'name': '', 'slug': ''};

            // if a parent classification is already selected
            if (dataField.length === 1) {
                parent = dataField[0].facet_count.item;
                parent = {'name': parent.name, 'slug': parent.slug};
                dataClass = dataField[0].children;
            } else {
                // if we have no parent classifications load those instead of subs
                for (var i = 0; i < dataField.length; i++) {
                    dataClass.push(dataField[i]);
                }
            }

            $.each(dataClass, function (index, itemData) {
                var temp = itemData.facet_count.item;
                cleanData[cleanData.length] = {
                        'name': temp.name,
                        'slug': temp.slug,
                        'value': JSON.stringify([
                            parent,
                                {
                                    'name': temp.name,
                                    'slug': temp.slug
                                }
                            ])
                };
            });
        }

        $facetsMenu.find('.facet-classifications')
                   .data('widget', 'list')
                   .data('data', cleanData);

        if (current) {
            if (current.hasOwnProperty('name') && current.name) {
                $facetsMenu.find('.facet-classifications')
                           .addClass('selected')
                           .data('value', current.value)
                           .find('.value')
                           .html(current.name);
            }
        }

        //Locality stuff
        current = selectedData[$facetsMenu.find('.facet-suburb').data('slug')];
        cleanData = [];
        dataField = '';
        if (facetData) {
            dataField = facetData.locality_facets;
        }

        $.each(dataField, function (index, itemData) {
            var cleanChildData = [];

            $.each(itemData, function (childIndex, childData) {
                cleanChildData[cleanChildData.length] = {
                                                        'name': childData[0].name,
                                                        'slug': childData[0].id,
                                                        'parent': childData[0].state,
                                                        'total': childData[1],
                                                        'value': JSON.stringify(childData[0])
                                                        };
            });

            cleanData[cleanData.length] = { 'name': index, 'children': JSON.stringify(cleanChildData) };
        });

        $facetsMenu.find('.facet-suburb')
                   .data('widget', 'list')
                   .data('data', cleanData);

        if (current.hasOwnProperty('name')) {
            $facetsMenu.find('.facet-suburb')
                       .addClass('selected')
                       .find('.value')
                       .html(current.name);
        }

        // Price Range stuff
        if (facetData && facetData.has_price_facets === true) {
            $facetsMenu.find('.facet-price').show();
            current = selectedData[$facetsMenu.find('.facet-price').data('slug')];
            if (current) {
                if (current.hasOwnProperty('min') || current.hasOwnProperty('max')) {
                    if (current.min !== '' || current.max !== '') {
                        $facetsMenu.find('.facet-price')
                                   .addClass('selected')
                                   .find('.value')
                                   .html(rangeString(current.min, current.max));
                    }
                }
            }
            $facetsMenu.find('.facet-price')
                       .data('widget', 'range');
        } else {
            $facetsMenu.find('.facet-price').hide();
        }

        // Refined facets stuff
        $facetsMenu.find('.facetExtras').html('');
        if (facetData && _.size(facetData.refined_facets) > 0) {
            var template = $('#hdlbars-facet-item').html();
            var compiled = Handlebars.compile(template);
            var properties = facetData.refined_facets.core_properties_structured;

            if (_.size(facetData.refined_facets.ad_attributes_structured) > 0) {
                $.each(facetData.refined_facets.ad_attributes_structured, function (index, itemData) {
                    properties[index] = itemData;
                });
            }

            if (_.size(facetData.refined_facets.ad_features_structured) > 0) {
                properties.featured = facetData.refined_facets.ad_features_structured.features;
            }

            $.each(properties, function (index, itemData) {
                var cleanChildData = [];

                var widget = '';
                switch (itemData.template) {
                    case 'freeform.html':
                        widget = 'keyword';
                        break;
                    case 'link.html':
                        widget = 'list';
                        break;
                    case 'range.html':
                        widget = 'range';
                        break;
                    case 'checkbox.html':
                        widget = 'multiselect';
                        break;
                    default:
                        widget = 'list';
                        break;
                }

                if (widget === 'list' || widget === 'multiselect') {
                    $.each(itemData.children, function (childIndex, childData) {
                        cleanChildData[cleanChildData.length] = {
                            'name': childData.label,
                            'slug': childData.slug,
                            'total': childData.count,
                            'value': JSON.stringify({ 'name': childData.label, 'slug': childData.slug}),
                            'widget': widget
                        };
                    });
                } else if (widget === 'range') {

                    if (firstRun === true) {
                        /*
                        if its a range widget we need to grab the range values from the url, if a value
                        exists we then need to populate selectedData with the values and setup the
                        breadcrumbs selected facets, this should definitely be done in the template and not in js
                        */
                        if (urlParams[itemData.slug]) {
                            var rangeVal = urlParams[itemData.slug];
                            var rangeSplit = rangeVal.split('-');
                            var stringVal = '';

                            selectedData[itemData.slug] = {
                                'slug': itemData.slug,
                                'min': rangeSplit[0],
                                'max': rangeSplit[1],
                                'widget': widget
                            };

                            stringVal += itemData.label + ': ';
                            stringVal += rangeString(rangeSplit[0], rangeSplit[1]);

                            breadcrumbAdd(itemData.slug, stringVal);
                        }
                    }

                    cleanChildData = { 'slug': '', 'min': '', 'max': ''};

                } else if (widget === 'keyword') {
                    if (firstRun === true) {
                        /*
                        if the widget is a keyword we need to grab the values from the url
                        and populate the selected crap, this needs to change
                        */
                        if (urlParams[itemData.slug]) {
                            var value = urlParams[itemData.slug];

                            selectedData[itemData.slug] = {
                                value: value
                            };

                            breadcrumbAdd(itemData.slug, value);
                        }
                    }
                }
                var data = { 'label': itemData.label, 'slug': itemData.slug };
                var $html = $(compiled(data));

                current = selectedData[itemData.slug];

                $html.data('widget', widget)
                     .data('slug', itemData.slug)
                     .data('max_value', itemData.max_value)
                     .data('data', cleanChildData);

                if (current) {

                    // if its an array loop through them
                    if (current.length > 0) {
                        var temp = '';
                        for (var i = 0; i < current.length; i++) {
                            if (i > 0) {
                                temp += ' / ';
                            }
                            temp += current[i].name;
                        }

                        $html.addClass('selected')
                             .find('.value')
                             .html(temp);
                    } else {

                        if (current.hasOwnProperty('name') || current.hasOwnProperty('value') ||
                                current.hasOwnProperty('min') || current.hasOwnProperty('max')) {

                                    var htmlVal = current.name;
                                    if (widget === 'range') {
                                        htmlVal = rangeString(current.min, current.max);
                                    } else if (widget === 'keyword') {
                                        htmlVal = current.value;
                                    }

                                    $html.addClass('selected')
                                         .find('.value')
                                         .html(htmlVal);
                        }
                    }
                }
                $facetsMenu.find('.facetExtras').append($html);

            });
        }

        // add the total number of results to the view results button
        if (facetData && facetData.hasOwnProperty('total')) {
            var total = facetData.total;
            updateTotalResults(total);
        } else {
            updateTotalResults('');
        }

        // Setup events for each item
        $facetsMenu.find('.listItem').each(function () {
            var $edit = $(this).find('.edit');
            var $action = $(this).find('.action');
            var $title = $(this).find('.title');

            $edit.unbind('click').click(function (e) {
                e.preventDefault();
                editClick($(this));
            });

            $action.unbind('click').click(function (e) {
                e.preventDefault();
                actionClick($(this));
            });
            $title.unbind('click').click(function () {
                if ($(this).parent().hasClass('selected')) {
                    editClick($(this));
                } else {
                    actionClick($(this));
                }
            });
        });

        $('body, html').css({ height: $facetsMenu.height() + 'px'});
    }

    function actionClick($link) {
        var $parent = $link.closest('.listItem');
        // if its open, reset state and get updated facet data
        if ($parent.hasClass('selected')) {
            $parent.data('value', '');

            // i hate having to do this but we really need to treat classifications differently
            if ($parent.data('slug') === 'classification') {
                var data = selectedData.classification;
                // drop the lowest level classification
                data.pop();
                selectedData.classification = data;
            } else {
                selectedData[$parent.data('slug')] = {};
            }
            $parent.removeClass('selected')
                   .find('.value')
                   .html('');

            getFacetData(true);

        } else {
            editClick($link);
        }

    }

    function editClick($link) {
        var $parent = $link.closest('.listItem');
        var data = $parent.data('data');
        var max_value=$parent.data('max_value');
        var widgetType = $parent.data('widget');
        var slug = $parent.data('slug');
        var template;

        console.log(data);

        if (max_value !== undefined)
            data['max_value'] = max_value;

        if (widgetType) {
            template = $('#hdlbars-classifieds-' + widgetType).html();
        }
        if (template) {
            var compiled = Handlebars.compile(template);
            var html = compiled(data);
            if(html) {
                var $html = $(html);

                $html.addClass('openedWidget');
                $parent.addClass('opened');
                $facetsMenu.find('.listAll').hide();
                $facetsMenu.find('.listWidgetContent').append($html);
                $facetsMenu.find('#facetMain').hide();

                var $widget = $facetsMenu.find('.openedWidget');

                cancelWidget($widget);

                switch (widgetType) {
                    case 'keyword':
                        keywordWidget($widget);
                        break;
                    case 'range':
                        rangeWidget($widget);
                        break;
                    case 'list':
                        listWidget($widget);
                        break;
                    case 'multiselect':
                        multiselectWidget($widget, slug);
                        break;
                    default:
                        listWidget($widget);
                        break;
                }
            }
        }
    }

    function cancelWidget($widget) {
        $widget.on('click', '.cancelWidget', function (e) {
            e.preventDefault();
            closeSelectedFacet();
        });
    }

    function resizeWindow() {
        var height = $facetsMenu.height();
        $('body, html').css({ height: height + 'px', overflow: 'hidden'});
    }

    function closeSelectedFacet() {
        $facetsMenu.find('.item:not(#facetMain)').remove();
        $facetsMenu.find('#facetMain').show().find('.opened').removeClass('opened');
        $facetsMenu.find('.listAll').show();
    }

    function closeFacets($facets) {
        $facets.removeClass('open');
        closeSelectedFacet();
        $facetsMenu.find('.opened')
                   .removeClass('opened')
                   .end()
                   .find('.facetExtras')
                   .html('');

        $('body, html').css({ height: 'auto', overflow: 'visible'});
        $(window).unbind('resize');
    }

    function listKeyword($list) {
        var $input = $list.find('.keywords');
        if ($input) {
            var $btn = $list.find($input.data('btn'));
            if ($btn) {
                $btn.click(function (e) {
                    e.preventDefault();
                    listGotoURL($list, $input);
                });
            }
            $input.keypress(function(e) {
                if(e.which === 13) {
                    listGotoURL($list, $input);
                }
            });
        }
    }

    /*
    This generates the search url, it'd be good if this wasn't so specific but
    the search url is pretty specific and this does the job
    */
    function generateUrl() {

        var paths = '/';
        var query = '';
        var props = JSON.parse(JSON.stringify(selectedData)); // making a deep clone as we're using delete below
        var curObject;

        if (window.location.href.indexOf("classifieds") > -1) {
            paths += 'classifieds/';
        }

        // generate specific paths for specific facets
        if (props.location) {
            curObject = props.location;
            if (curObject.hasOwnProperty('slug')) {
                if (curObject.slug !== '') {
                    paths += curObject.slug + '/';
                } else {
                    paths += 'all-locations/';
                }
            } else {
                paths += 'all-locations/';
            }
            delete props.location;
        } else {
            paths += 'all-locations/';
        }
        if (props.classification) {
            curObject = props.classification;
            if (curObject.length > 0) {
                for (var i = 0; i < curObject.length; i++) {
                    if (curObject[i].hasOwnProperty('slug') && curObject[i].slug) {
                        paths += curObject[i].slug + '/';
                    }
                }
            }
            delete props.classification;
        }
        if (props.keyword) {
            curObject = props.keyword;
            if (curObject.hasOwnProperty('value')) {
                if (curObject.value !== '') {
                    query += 'keywords=' + curObject.value + '&';
                }
            }
            delete props.keyword;
        }
        if (props.price) {
            curObject = props.price;
            if (curObject.hasOwnProperty('min') || curObject.hasOwnProperty('max')) {
                if (curObject.min !== '' || curObject.max !== '') {
                    query += 'price=' + curObject.min + '-' + curObject.max + '&';
                }
            }
            delete props.price;
        }
        if (props.suburb) {
            curObject = props.suburb;
            if (curObject.hasOwnProperty('id')) {
                if (curObject.value !== '') {
                    query += 'suburb=' + curObject.id + '&';
                }
            }
            delete props.suburb;
        }
        if (props.features) {
            curObject = props.features;
            for (var j = 0; j < curObject.length; j++) {
                paths += curObject[j].slug + '/';
            }
            delete props.features;
        }
        // loop through the left over facets and add them to the path
        $.each(props, function (index, value) {
            if (value.hasOwnProperty('slug')) {
                if (value.slug !== '') {
                    // if its a range value treat it like its your useless bastard stepson
                    if (value.widget === 'range') {
                        query += value.slug + '=' + value.min + '-' + value.max + '&';
                    } else if (value.widget === 'keyword'){
                        query += value.slug + '=' + value.value + '&';
                    } else {
                        paths += value.slug + '/';
                    }
                }
            }
        });

        if (query !== '') {

            if (query.substr(query.length - 1) === '&') {
                query = query.slice(0, -1);
            }

            paths += '?' + query;
        }
        document.location.href = paths;

    }

    // this is only for the landing page list
    function listGotoURL($list, $input) {
        $input = $input || $list.find('.keywords');

        var val = $input.val(),
            href = $list.data('href');

        if (val) {
            href += '?keywords=' + val;
        }
        document.location.href = href;
    }

    function startLoading() {
        $facetsMenu.append('<div class="loading-bg">');
        $facetsMenu.append('<div class="loading-progress progress">' +
                            '<div class="progress-bar progress-bar-striped active" role="progressbar" style="width:100%"></div>' +
                            '</div></div>');
    }

    function finishLoading() {
        $facetsMenu.find('.loading-bg').remove();
        $facetsMenu.find('.loading-progress').remove();
    }

    function errorAlert($parent, msg) {
        $parent.prepend('<div class="alert alert-danger" role="alert">' +
                         msg +
                        '</div>');
    }

    function removeAlert() {
        $facetsMenu.find('.alert').remove();
    }

    function rangeString(min, max) {
        var stringVal = '';
        if (min) {
            stringVal += min;
        } else {
            stringVal += '0';
        }
        if (max) {
            stringVal += ' - ' + max;
        } else {
            stringVal += '+';
        }
        return stringVal;
    }

    function updateTotalResults(total) {
        $facetsMenu.find('.totalResults').html(total + ' ');

        // if theres only one result hide the plural s
        if (total === 1) {
            $facetsMenu.find('.totalResultsAfter').hide();
        } else {
            $facetsMenu.find('.totalResultsAfter').show();
        }
    }

    function breadcrumbs() {
        $('.keyword-tag').click(function(e) {
            e.preventDefault();
            removeParam(window.location.href.split("?")[0], 'keywords');
        });
        $('.price-tag').click(function(e) {
            e.preventDefault();
            removeParam(window.location.href.split("?")[0], 'price');
        });
    }

    function breadcrumbAdd(slug, value) {
        $('.classifieds-selected-facets').append('<a href="#" class="facetSelected-' +
                                                    slug +
                                                    '">' +
                                                    value +
                                                    '<i></i></a>');

        $('.classifieds-selected-facets').on('click', '.facetSelected-' + slug, function (e) {
            e.preventDefault();
            removeParam(window.location.href.split("?")[0], slug);
        });
    }

    function removeParam(url, key) {
        delete urlParams[key];
        var query_string = $.param(urlParams);
        window.location.href = query_string ? url + '?' + query_string : url;
    }

    function initClassifiedsSearch(){
        $facetsMenu = $('#facetsMenu');

        if ($('.landingWidget').length > 0) {
            landingWidget($('.landingWidget'));
        }

        if ($('.search-results').length > 0) {
            initFacets();
            breadcrumbs();
            if ($facetsMenu.length > 0) {
                getFacetData(true);
            }
        }
    }

    rnn.modules.register('classifiedsSearch', {
        init: initClassifiedsSearch
    });

})(jQuery);

(window.onpopstate = function () {
    var match;
    var pl     = /\+/g;  // Regex for replacing addition symbol with a space
    var search = /([^&=]+)=?([^&]*)/g;
    var decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); };
    var query  = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
       urlParams[decode(match[1])] = decode(match[2]);
})();